import { useEffect, useState } from 'react';

import { FriendList } from './FriendList';
import { FriendRequests } from './FriendRequests';
import { FriendSearch } from './FriendSearch';
import { useFriends } from './store';
import styles from './friends.module.css';

type Tab = 'friends' | 'requests';

export function FriendPanel(): JSX.Element {
  const [tab, setTab] = useState<Tab>('friends');
  const loadFriends = useFriends((s) => s.loadFriends);
  const loadRequests = useFriends((s) => s.loadRequests);
  const incomingCount = useFriends((s) => s.pendingIncoming.length);

  useEffect(() => {
    void loadFriends();
    void loadRequests();

    const interval = setInterval(() => {
      void loadFriends();
      void loadRequests();
    }, 60_000);
    return () => clearInterval(interval);
  }, [loadFriends, loadRequests]);

  return (
    <div className={styles.panel}>
      <div className={styles.panelHeader}>Friends</div>
      <FriendSearch />
      <div className={styles.tabs}>
        <button
          className={`${styles.tab} ${tab === 'friends' ? styles.tabActive : ''}`}
          onClick={() => setTab('friends')}
        >
          Friends
        </button>
        <button
          className={`${styles.tab} ${tab === 'requests' ? styles.tabActive : ''}`}
          onClick={() => setTab('requests')}
        >
          Requests
          {incomingCount > 0 && (
            <span className={styles.badge}>{incomingCount}</span>
          )}
        </button>
      </div>
      {tab === 'friends' ? <FriendList /> : <FriendRequests />}
    </div>
  );
}
